import type { Extrusion } from "geom/brep";
import { offsetPolyLine2 } from "geom/offset";
import { polyLine2SetCW, polyLine2SetCCW } from "geom/polyLine2";
import type { PolyLine2 } from "geom/polyLine2Types";

//adhoc tolerance to hide floor extruded faces
const FLOOR_EXTRUDED_FACE_HIDING_TOLERANCE = 0.05;

export function processFloorExtrusions(floorExtrusions: Extrusion[]) {
  const editedFloorExtrusions: Extrusion[] = [];
  for (const floorExtrusion of floorExtrusions) {
    const updateFloorLoops: PolyLine2[] = [];
    for (let loopIndex = 0; loopIndex < floorExtrusion.profile.loops.length; loopIndex++) {
      const orientedLoop =
        loopIndex === 0
          ? polyLine2SetCW(
              offsetPolyLine2(floorExtrusion.profile.loops[loopIndex], FLOOR_EXTRUDED_FACE_HIDING_TOLERANCE),
            )
          : polyLine2SetCCW(
              offsetPolyLine2(floorExtrusion.profile.loops[loopIndex], FLOOR_EXTRUDED_FACE_HIDING_TOLERANCE),
            );
      updateFloorLoops.push(orientedLoop);
    }
    const editedFloorExtrusion: Extrusion = {
      ...floorExtrusion,
      profile: { ...floorExtrusion.profile, loops: updateFloorLoops },
    };
    updateFloorLoops.length > 0 ? editedFloorExtrusions.push(editedFloorExtrusion) : 0;
  }
  return editedFloorExtrusions;
}
